import { React, useState, useEffect } from "react";
import "./Emulator.css"
import { message } from "antd";
import { useNavigate } from "react-router-dom";

function isInBounds(state, coordX, coordY) {
    return coordX >= state.topLeft.x
        && coordX <= state.bottomRight.x
        && coordY >= state.topLeft.y
        && coordY <= state.bottomRight.y
}

export default function Emulator(props) {
    const navigate = useNavigate();

    const [ tries, setTries ] = useState(0);
    const [ msgActive, setMsgActive ] = useState("");

    useEffect(() => {
        setTries(0);
        message.destroy();
        setMsgActive(null);
    }, [props.state]);

    return (
        <>
        {/* <div className="phone"> */}
            <div className="imgContainer">
                {(!props.state.fin && !props.state.branch) && tries > 1 &&
                    <img
                        src="/hand-index-thumb-fill.svg" 
                        className="grow toolPointer"
                        style={{
                            top: (props.state.bottomRight.y + props.state.topLeft.y) / 2,
                            left: (props.state.bottomRight.x + props.state.topLeft.x) / 2 
                        }} />
                }
                <img className="phoneDisplay" src={ props.state.img }
                    onClick={(e) => {
                        if (!props.state.fin) {
                            const bounds = e.currentTarget.getBoundingClientRect();
                            const coordX = e.pageX - bounds.left - window.scrollX;
                            const coordY = e.pageY - bounds.top - window.scrollY;

                            if (props.state.branch) {
                                if (props.setParentTries)
                                    props.setParentTries(tries + 1);
                                
                                setTries(tries + 1);
                                for (const b of props.state.conds) {
                                    if (isInBounds(b, coordX, coordY)) {
                                        if (props.logger)
                                            props.logger(tries);
                                        
                                        navigate(props.brancher.replace(":branchid", b.name));
                                    }
                                }
                            }
                            else if (isInBounds(props.state, coordX, coordY)) {
                                if (!props.state.remainScrolled)
                                    e.currentTarget.parentElement.scroll(0, 0);
                                if (props.updateState)
                                    props.updateState();
                                
                                if (props.logger)
                                    props.logger(tries);

                                if (props.setParentTries)
                                    props.setParentTries(tries);
                                

                                message.destroy();
                                setMsgActive(null);
                                setTries(0);
                            } else {
                                if (props.setParentTries)
                                    props.setParentTries(tries + 1);
                                
                                setTries(tries + 1);
                                if (props.state.hasOwnProperty("wrongMsg") && msgActive !== props.state.wrongMsg)
                                {
                                    message.destroy();
                                    setMsgActive(props.state.wrongMsg);
                                    message.error(props.state.wrongMsg).then(() => setMsgActive(null));
                                }
                            }
                        }
                }} />
            </div>
        {/* </div> */}
        </>
    );
}
